import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = {
  path: '/payments',
  exact: true,
  page: getLoadablePage(() => import(/* webpackChunkName: "payments" */ '../pages/payments-definition')),
  chunkName: 'payments',
  methods: 'get,post',
};
